export interface DescribeEditorsArgs {
  /** The people in the room this browser can put a name to. */
  names: string[]
  /**
   * How many of them it cannot: somebody from another organization, or a
   * client that never said who it was. Zero where everybody is named.
   */
  unnamed: number
}

/** Who is editing, said the way one person would say it to another. */
export const describeEditors = ({
  names,
  unnamed,
}: DescribeEditorsArgs): string => {
  if (names.length === 0) {
    return unnamed > 1
      ? `${unnamed} people are editing this file right now.`
      : 'Someone is editing this file right now.'
  }

  const parts = [...names]
  if (unnamed === 1) {
    parts.push('someone else')
  } else if (unnamed > 1) {
    parts.push(`${unnamed} others`)
  }

  const who =
    parts.length === 1
      ? parts[0]
      : `${parts.slice(0, -1).join(', ')} and ${parts[parts.length - 1]}`
  return `${who} ${parts.length === 1 ? 'is' : 'are'} editing this file right now.`
}
